<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" [disabled]=vb.disabled></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Navigation</ion-title>
        @if (!vb.disabled) {
  <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
}

        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>

            <ion-button id="next" (click)="onNextClick()">
                <ion-icon name="arrow-forward"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <ion-list-header color="secondary">
        Ticket Summary - (Step 2 of 5)
    </ion-list-header>

    <ion-list class="ion-text-wrap radio-group">

        <ion-item-divider color="tertiary">
            <!-- {{vm.numDropoffsStr}} How many customers are present? -->
            Dropoff Tickets - Take Attendance
        </ion-item-divider>

        @if (dropoffTicketsExists()) {
  <div>
            @for (ticket of vm.dropoffTickets; track $index) {
  <ion-item [disabled]=vb.disabled>
                <ion-label class="ion-text-wrap" [class.urgent]="ticket.isUrgent">
                    <span class="line1">{{ticket.passengerName}}{{ticket.numPassengersStr}}</span><br />
                    <span class="line2">{{ticket.attendanceStr}}</span>
                </ion-label>
                <ion-toggle data-test="attendanceToggle" [(ngModel)]="ticket.attendance" (ionChange)="onAttendanceChange(ticket)"></ion-toggle>
            </ion-item>
}
        </div>
}

        @if (!dropoffTicketsExists()) {
  <div>
            <ion-item>
                <ion-label class="ion-text-wrap">
                    <span class="line2">
                        No dropoff tickets defined for this route so there is no need to take attendance.  Click Next.
                    </span>
                </ion-label>
            </ion-item>
        </div>
}
    </ion-list>

    <ion-list>
        <ion-item-divider color="tertiary">
            Pickup Tickets
        </ion-item-divider>

        @if (pickupTicketsExists()) {
  <div>
            @for (ticket of pickupTickets; track $index) {
  <ion-item [disabled]=vb.disabled>
                <ion-label class="ion-text-wrap" [class.urgent]="ticket.isUrgent">
                    <span class="line1">{{ticket.passengerName}}{{ticket.numPassengersStr}}</span><br />
                    <span class="line2">{{ticket.attendanceStr}}</span>
                </ion-label>
            </ion-item>
}    
        </div>
}
    </ion-list>

    <ion-list lines="none">
        @if (!pickupTicketsExists()) {
  <ion-item color="info" class="ion-margin">
            <ion-label class="infoMsg ion-text-wrap">
                No pickup tickets defined for this route.
            </ion-label>
        </ion-item>
}
    </ion-list>
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button data-test="nextButton" [disabled]="vb.disabled || !vm.step2Complete" title="Next" (click)="onNextClick()">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>